import { rumAction, logToast } from './rum';

// =====================================================================
// Toast telemetry, at the abstraction rather than per toast, so every future
// toast is measurable without its author remembering to wire anything.
//
// The funnel these three answer:
//   shown     -> the SDR was actually shown it (NOT the same as "the condition
//                was true" — a dismissed toast stays suppressed while its
//                condition keeps firing, so condition counts overcount exposure)
//   action    -> they took the offered fix
//   dismissed -> they closed it without fixing
//
// "shown but neither actioned nor dismissed" is the interesting fourth case and
// falls out of the arithmetic: it means they ignored it, which needs a different
// response from dismissing (ignored -> not visible enough; dismissed -> visible
// and unwanted).
//
// `ms` is time on screen before the SDR acted. A dismiss at 400ms is a reflex
// swat; at 30s it is a considered no.
// =====================================================================

export type ToastOutcome = 'shown' | 'dismissed' | 'action';

export function reportToast(outcome: ToastOutcome, toastId: string, msOnScreen?: number): void {
  const context: Record<string, unknown> = {
    // The stable key dashboards/monitors filter on — never the prose title
    // (repo convention, see infrastructure/datadog/monitors/features.ts).
    event: `cockpit_toast_${outcome}`,
    toast_id: toastId,
  };
  if (msOnScreen !== undefined) context.ms_on_screen = Math.round(msOnScreen);
  rumAction(`cockpit.toast.${outcome}`, context);
  logToast(outcome, context);
}
